import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isRoomDropdownOpen, setIsRoomDropdownOpen] = useState(false);
  const [isDestinationDropdownOpen, setIsDestinationDropdownOpen] =
    useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleRoomHover = () => {
    setIsRoomDropdownOpen(true);
  };

  const handleRoomLeave = () => {
    setIsRoomDropdownOpen(false);
  };

  const handleDestinationHover = () => {
    setIsDestinationDropdownOpen(true);
  };

  const handleDestinationLeave = () => {
    setIsDestinationDropdownOpen(false);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const destinations = [
    {
      name: "Noida",
      path: "/noida",
      image:
        "https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus5.jpg",
    },
    {
      name: "Rishikesh",
      path: "/destination",
      image: "/destination1.jpeg",
    },
  ];

  const rooms = [
    {
      name: "Suite Room City View",
      path: "/suiteroomcityview",
      image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room1.jpg",
    },
    {
      name: "Suite Room Pool View",
      path: "/suiteroompoolview",
      image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room2.jpg",
    },
    {
      name: "Executive Suite",
      path: "/executivesuite",
      image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room3.jpg",
    },
  ];

  return (
    <div className="navBarContainer">
      <div className="logoContainer">
        <Link to="/">
          <img
            src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/logo.png"
            className="logo"
            alt="Logo"
          />
        </Link>
      </div>

      <div className="hamburgerContainer" onClick={toggleMenu}>
        <span className={`hamburgerLine ${isMenuOpen ? "active" : ""}`}></span>
        <span className={`hamburgerLine ${isMenuOpen ? "active" : ""}`}></span>
        <span className={`hamburgerLine ${isMenuOpen ? "active" : ""}`}></span>
      </div>

      <div className="quickLinksContainer">
        <div
          className="roomsDropdownContainer"
          onMouseEnter={handleDestinationHover}
          onMouseLeave={handleDestinationLeave}
        >
          <span className="navLink roomsLink">Destinations</span>
          <div
            className={`roomsDropdown ${
              isDestinationDropdownOpen ? "open" : ""
            }`}
          >
            {destinations.map((destination, index) => (
              <Link
                key={index}
                to={destination.path}
                className="roomDropdownItem"
                onClick={() => setIsDestinationDropdownOpen(false)}
              >
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="roomDropdownImage"
                />
                <span className="roomDropdownName">{destination.name}</span>
              </Link>
            ))}
          </div>
        </div>

        <div
          className="roomsDropdownContainer"
          onMouseEnter={handleRoomHover}
          onMouseLeave={handleRoomLeave}
        >
          <span className="navLink roomsLink">Rooms</span>
          <div className={`roomsDropdown ${isRoomDropdownOpen ? "open" : ""}`}>
            {rooms.map((room, index) => (
              <Link
                key={index}
                to={room.path}
                className="roomDropdownItem"
                onClick={() => setIsRoomDropdownOpen(false)}
              >
                <img
                  src={room.image}
                  alt={room.name}
                  className="roomDropdownImage"
                />
                <span className="roomDropdownName">{room.name}</span>
              </Link>
            ))}
          </div>
        </div>

        <Link to="/contact" className="navLink">
          Contact
        </Link>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobileMenuOverlay ${isMenuOpen ? "open" : ""}`}>
        <div className="mobileMenuContent">
          <div className="mobileQuickLinks">
            <div className="mobileRoomsSection">
              <p className="mobileRoomsTitle">Destinations</p>
              <div className="mobileRoomsList">
                {destinations.map((destination, index) => (
                  <Link
                    key={index}
                    to={destination.path}
                    className="mobileRoomItem"
                    onClick={closeMenu}
                  >
                    <img
                      src={destination.image}
                      alt={destination.name}
                      className="mobileRoomImage"
                    />
                    <span>{destination.name}</span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="mobileRoomsSection">
              <p className="mobileRoomsTitle">Rooms</p>
              <div className="mobileRoomsList">
                {rooms.map((room, index) => (
                  <Link
                    key={index}
                    to={room.path}
                    className="mobileRoomItem"
                    onClick={closeMenu}
                  >
                    <img
                      src={room.image}
                      alt={room.name}
                      className="mobileRoomImage"
                    />
                    <span>{room.name}</span>
                  </Link>
                ))}
              </div>
            </div>

            <Link to="/contact" onClick={closeMenu}>
              Contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
